import { render, staticRenderFns } from "./battleNetUser.vue?vue&type=template&id=583a24d6&scoped=true"
import script from "./battleNetUser.vue?vue&type=script&lang=js"
export * from "./battleNetUser.vue?vue&type=script&lang=js"
import style0 from "./battleNetUser.vue?vue&type=style&index=0&id=583a24d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a24d6",
  null
  
)

export default component.exports